import { removeLinkParams } from './link';
var baseSpotifyPath = 'open.spotify.com/';
var baseEmbeddedPath = 'https://open.spotify.com/embed/';
var createEmbeddedLink = function (link) {
    var finalPath = removeLinkParams(link.split(baseSpotifyPath)[1]);
    return "" + baseEmbeddedPath + finalPath;
};
var getHeight = function (link) {
    if (link.includes(baseSpotifyPath + "track") ||
        link.includes(baseSpotifyPath + "artist") ||
        link.includes(baseSpotifyPath + "playlist")) {
        return 380;
    }
    if (link.includes(baseSpotifyPath + "show") ||
        link.includes(baseSpotifyPath + "episode")) {
        return 232;
    }
};
export var spotify = {
    category: 'AUDIO',
    isSatisfied: function (link) { return link.includes(baseSpotifyPath); },
    getPlayerExecutionProps: function (link) { return ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media',
        responsive: true,
        height: getHeight(link),
    }); },
};
